module.exports = __webpack_public_path__ + "img/mv_monde-selection_trophy1.3ff6cda3.jpg";